import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// PrimeNG modules
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';

// Components
import { NotificationDropdownComponent } from './components/notification-dropdown/notification-dropdown.component';
import { NotificationIconComponent } from './components/notification-icon/notification-icon.component';

// Services
import { NotificationsService } from './services/notifications.service';
import { NotificationNavigationService } from './services/notification-navigation.service';

@NgModule({
  declarations: [
    NotificationDropdownComponent,
    NotificationIconComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ButtonModule,
    BadgeModule,
    OverlayPanelModule,
    ScrollPanelModule,
    TooltipModule,
    RippleModule
  ],
  providers: [
    // Services are provided in root via @Injectable decorator
  ],
  exports: [
    NotificationDropdownComponent,
    NotificationIconComponent
  ]
})
export class NotificationsModule { }
